import { cn } from '../lib/cn';

// ─────────────────────────────────────────────────────────────────────────────
// CompProgressDots — the compact per-competition-row progress read (Setup-page
// progress redesign, 2026-07-16). Phase 4 put ONE go-live checklist at the top
// of the Setup page, tied to whichever competition happened to be selected —
// with 2+ comps in an org that read as "there's only one competition" (Lisa's
// PO feedback). This renders instead, once per row, so three comps in a list
// show three unambiguous N/5 reads.
//
// Deliberately subtle — same accent-500 used everywhere else on this page (the
// strip's own ✓ colour), just filled vs. dim dots. No severity colour (no
// red/amber/green ramp) — restraint over a traffic-light strip.
// ─────────────────────────────────────────────────────────────────────────────

export function CompProgressDots({
  readyCount,
  totalCount,
}: {
  readyCount: number;
  totalCount: number;
}) {
  return (
    <span
      className="inline-flex items-center gap-1.5"
      title={`${readyCount}/${totalCount} go-live steps complete`}
    >
      <span className="flex items-center gap-0.5">
        {Array.from({ length: totalCount }).map((_, i) => (
          <span
            key={i}
            className={cn(
              'h-1.5 w-1.5 rounded-full',
              i < readyCount ? 'bg-accent-500' : 'bg-white/[0.12]',
            )}
          />
        ))}
      </span>
      <span className="font-mono text-[10px] text-ink-meta">{readyCount}/{totalCount}</span>
    </span>
  );
}
